import { render, staticRenderFns } from "./InraOralComponent.vue?vue&type=template&id=bd20394e&"
import script from "./InraOralComponent.vue?vue&type=script&lang=js&"
export * from "./InraOralComponent.vue?vue&type=script&lang=js&"
import style0 from "./InraOralComponent.vue?vue&type=style&index=0&id=bd20394e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports